import { render, staticRenderFns } from "./SystemNotice.vue?vue&type=template&id=7b0d9415"
import script from "./SystemNotice.vue?vue&type=script&lang=ts"
export * from "./SystemNotice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports